module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-drozdowska-f83839c2025534ec4872fd6fbdc9e8b2.png";